<template>
  <div class="rechargeDetail">
    <Header :title="title" :right-content="rightContent" />
    <div id="content" :class="pageType == 'app'?'isApp':''">
      <div class="layout">
        <div class="amount">
          <div class="item"><em><span v-if="recordType != 2 && recordType != 'transfer'">+</span>$</em><span>{{
              transAmount }}</span></div>
          <p v-if="recordType != 2 && recordType != 'transfer'">{{
            proposalStatus==1?"处理中":proposalStatus==2?"成功":proposalStatus==-2?"逾期":proposalStatus==-3?"失败":"已取消" }}</p>
        </div>
        <div class="orderCon">
          <div class="orderList">
            <ul>
              <li v-if="recordType != 2 && recordType != 'transfer'">
                <p>{{ recordType==0||recordType=='deposit'?"付款方式":"付款账号" }}</p><span>{{ payType }}</span>
              </li>
              <!--<li v-if="payType=='快捷支付'"><p>转账说明</p><span>{{remark}}</span></li>-->
              <li v-if="recordType == 2 || recordType == 'transfer'">
                <p>转出平台</p><span>{{ fromPlatform }}</span>
              </li>
              <li v-if="recordType == 2 || recordType == 'transfer'">
                <p>转入平台</p><span>{{ toPlatform }}</span>
              </li>
              <!-- <li v-if="paymentType=='REAL_CURRENCY'"><p>提现金额(人民币)</p><span v-if="rate !== ''">¥{{ Math.round(parseFloat((payAmount - fee) * rate)) }}</span></li> -->
              <li v-if="paymentType == 'REAL_CURRENCY'">
                <p>提现金额(人民币)</p><span>¥{{ payAmount }}</span>
              </li>
              <!-- <li v-if="paymentType=='VIRTUAL_CURRENCY'">
                <p>到账金额</p><span v-if="rate !== ''">${{ parseFloat((payAmount - fee) * rate).toFixed(2) }}</span>
              </li> -->
              <li v-if="paymentType=='VIRTUAL_CURRENCY'">
                <p>到账金额</p><span>${{ payAmount }}</span>
              </li>
            </ul>
          </div>
          <div v-if="recordType != 2 && recordType != 'transfer'" class="progress">
            <div class="title">
              <p>处理进度</p>
            </div>
            <div class="progressCon">
              <ul>
                <li :class="proposalStatus==-1||proposalStatus==-2?&quot;&quot;:&quot;suc&quot;">
                  <em />
                  <span>提交成功</span>
                  <p>{{ new Date(createDate.replace(/-/g, "/")).format("MM-dd hh:mm") }}</p>
                </li>
                <!-- <li :class="proposalStatus==-1||proposalStatus==-2?&quot;&quot;:proposalStatus==2?&quot;suc suc-1&quot;:&quot;suc&quot;">
                  <em />
                  <span>平台处理中</span>
                  <p>{{ new Date(createDate.replace(/-/g, "/")).format("MM-dd hh:mm") }}</p>
                </li> -->
                <li v-if="proposalStatus!=1" :class="proposalStatus==2?&quot;sucLast&quot;:&quot;failLast&quot;">
                  <em />
                  <span v-if="recordType != 2 && recordType != 'transfer'">{{
                    proposalStatus==-1?'订单已取消':proposalStatus==-2?'订单逾期':proposalStatus==-3?'到账失败':'到账成功' }}</span>
                  <p>{{ new Date(updateDate&&updateDate.replace(/-/g, "/")).format("MM-dd hh:mm") }}</p>
                </li>
              </ul>
            </div>
          </div>
          <div v-if="payType=='快捷支付'" class="orderList">
            <ul>
              <li>
                <p>转账到</p><span>{{ payType }}</span>
              </li>
            </ul>
          </div>
          <div v-else class="orderList">
            <ul>
              <li v-if="recordType==1||recordType=='withdraw'">
                <p>取款至</p><span>{{ dueBank }}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="orderList">
          <ul>
            <li>
              <p>创建时间</p><span>{{ createDate }}</span>
            </li>
            <li>
              <p>订单号</p><span>{{ pno }}</span>
            </li>
          </ul>
        </div>
        <!-- <div v-if="paymentType == 'REAL_CURRENCY' && unconfirmedMatchList.length > 0" class="confirmWithdraw">
          <p>您有已到账的提现，请核对账户， 确认是否收到以下金额：</p>
          <ul>
            <li v-for="matchItem in unconfirmedMatchList" :key="`match-${matchItem.matchPno}`">
              <p>¥{{ matchItem.matchAmount }}</p>
              <div class="btn-group">
                <button style="margin-right: 10px"
                  @click="confirmMatch(matchItem.pno, matchItem.matchPno, matchItem.matchAmount, 2)">未到账</button>
                <button style="color: #0A95FF; border-color: #0A95FF;"
                  @click="confirmMatch(matchItem.pno, matchItem.matchPno, matchItem.matchAmount, 1)">确认到账</button>
              </div>
            </li>
          </ul>
          <p style="color: #FB605A">请务必核实到账后再点击确认到账</p>
          <p v-if="remainingUnpaidAmount > 0" style="color: #999">为保障资金安全， 您的取款将拆分支付， 剩余{{ remainingUnpaidAmount }}元支付中
          </p>
        </div> -->
      </div>
      <Chat />
    </div>
    <ToHome />

    <AlertPop :model="alertPop.show" :content="alertPop.content" :button1txt="alertPop.button1Txt"
      @alertOnClose="alertOnClose" />
  </div>
</template>

<script>
require('@/assets/css/rechargeDetail.css')
import Header from '@/view/module/Header.vue'
import Chat from '@/view/module/Chat.vue'
import ToHome from '@/view/module/ToHome.vue'
import '@/utils/tradeDataUtil'
import { mapState } from 'vuex'
import api from '@/plugins/api'
import AlertPop from '@/view/module/AlertPop.vue'

export default {
  name: 'RechargeDetail',
  components: { Header, Chat, ToHome, AlertPop },
  computed: {
    ...mapState(['pageType']),
    remainingUnpaidAmount: function() {
      return this.payAmount !== '' && this.rate !== '' && this.fee !== '' ? this.matchList.length > 0 ? Math.round(parseFloat((this.payAmount - this.fee) * this.rate)) - this.matchList.reduce((acc, matchItem) => acc + matchItem.matchAmount, 0) : Math.floor(parseFloat((this.payAmount - this.fee) * this.rate)) : '--'
    },
    unconfirmedMatchList: function() {
      return this.matchList.filter(match => !['RECEIVED', 'NOT_RECEIVED'].includes(match.confirmStatus))
    }
  },
  data() {
    return {
      title: '交易详情',
      rightContent: 'isNo',
      pno: this.$route.query.pno || '', remark: this.$route.query.remark || '',
      transAmount: this.$route.query.transAmount || '',
      payAmount: this.$route.query.payAmount || '',
      payType: this.$route.query.payType || '',
      createDate: this.$route.query.createDate || '',
      pendingExpireDate: this.$route.query.pendingExpireDate || '',
      updateDate: this.$route.query.updateDate || '',
      proposalStatus: this.$route.query.proposalStatus || '',
      dueBank: this.$route.query.dueBank || '',
      recordType: this.$route.query.recordType || '',
      paymentType: this.$route.query.paymentType || '',
      rate: (1 / this.$route.query.exchangeRate) || '',
      matchList: this.$route.query.matchList ? JSON.parse(this.$route.query.matchList) : [],
      fee: this.$route.query.fee,
      fromPlatform: this.$route.query.fromPlatform || '',
      toPlatform: this.$route.query.toPlatform || '',
      alertPop: {
        show: false
      },
    }
  },
  mounted() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
    // this.getRate()
  },
  activated() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
  },
  methods: {
    removeFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.remove('mainFixed')
    },
    getRate() {
      const data = {
        type: 2,
        sourceCurrency: 'USD',
        targetCurrency: 'CNY'
      }

      api.getRate(data).then((res) => {
        if (res.status && res.data.code == 200) {
          this.rate = res.data.data
        }
      })
    },
    confirmMatch(pno, matchPno, matchAmount, confirmStatus) {
      const data = {
        pno: pno,
        matchPno: matchPno,
        matchAmount: matchAmount,
        confirmStatus: confirmStatus
      }

      this.$bus.$emit('loading', false)

      api.confirmWithdraw(this.$qs.stringify(data)).then((res) => {
        this.$bus.$emit('loading', true)
        if (res.data.code == '200') {
          this.matchList = this.matchList.filter(matchItem => matchItem.matchPno != matchPno)
        } else if (res.data.code == 500) {
          this.alertPop = {
            show: true,
            content: res.data.code_desc,
            button1Txt: '知道了'
          }
        }
      })
    },
    alertOnClose() {
      this.alertPop.show = false
    }
  }
}
</script>
